module.exports = __webpack_public_path__ + "img/description.ef4ede2a.svg";